// extracted by mini-css-extract-plugin
export default {"root":"CompanyEditPage_root__6qGJz","header":"CompanyEditPage_header__JtIPD","tabs":"CompanyEditPage_tabs__h2fku"};